// src/features/formSlice.js
// src/features/formSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  accountNumber: '',
  dueDate: null,
  amount: {
    value: '',
    currency: '',
  },
  address: {
    postcode: '',
    houseName: '',
    street: '',
    city: '',
    country: '',
  },
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    updateFormField: (state, action) => {
      const { field, value } = action.payload;
      if (field.includes('.')) {
        const [parent, child] = field.split('.');
        state[parent][child] = value;
      } else {
        state[field] = value;
      }
    },
    resetForm: () => initialState,
  },
});

export const { updateFormField, resetForm } = formSlice.actions;
export default formSlice.reducer;
